import { render } from "./Terms.vue?vue&type=template&id=d50317a4"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Terms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d50317a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d50317a4', __exports__)) {
    api.reload('d50317a4', __exports__)
  }
  
  module.hot.accept("./Terms.vue?vue&type=template&id=d50317a4", () => {
    api.rerender('d50317a4', render)
  })

}


export default __exports__